// extracted by mini-css-extract-plugin
module.exports = {"container":"gallery4_container__2egQw","morePictures":"gallery4_morePictures__2cotf"};